import './App.css';
import Members from './components/Members/Members';

function App() {
  return (
    <div className="App">
      <Members></Members>
    </div>
  );
}

export default App;
